import { CatalogProductType } from '../enums'
import i18next from 'i18next'
import CatalogProduct, { SpineMultimeasurementCatalogProduct } from '../types/CatalogProduct'

export const translateCatalogProductType = (type: CatalogProductType) => {
  switch (type) {
    case CatalogProductType.ELECTRICAL_CABINET:
      return i18next.t('electricalCabinet', { ns: 'catalogProduct' })
    case CatalogProductType.SPINE_MODULE:
      return i18next.t('spineModule', { ns: 'catalogProduct' })
    case CatalogProductType.GENERATOR:
      return i18next.t('generator', { ns: 'catalogProduct' })
    case CatalogProductType.HEATER:
      return i18next.t('heater', { ns: 'catalogProduct' })
    case CatalogProductType.AURORA:
      return i18next.t('aurora', { ns: 'catalogProduct' })
  }
}

export function isSpineMultiMeasurementCatalogProduct(
  product: CatalogProduct
): product is SpineMultimeasurementCatalogProduct {
  return product.type === CatalogProductType.SPINE_MULTI_MEASUREMENT
}
